// extracted by mini-css-extract-plugin
export default {"viewerContainer":"TeaserViewer_viewerContainer__5CXiB","pdfList":"TeaserViewer_pdfList__LA6O1","pdfItem":"TeaserViewer_pdfItem__a8-s0","pdfFrame":"TeaserViewer_pdfFrame__AoLgi"};